<template>
  <section class="form pt-5">
    <div class="container-fluid">
      <div class="row d-flex">
        <div class="section-title">LET’S TALK</div>
        <div class="sub-title pb-5">
          Leave us a little info, and we’ll be in touch.
        </div>

        <div class="col-lg-6 left-part pb-5">
          <div v-if="success !== ''" class="alert alert-success">{{ success }}</div>
          <form>
            <div class="col-lg-6 mb-4">
              <label class="label form-label">Business Name<span class="star">*</span></label>
              <input v-model="businessName" type="text" class="form-control ps-0" placeholder="Business Name">
            </div>
            <div class="col-lg-6 mb-4">
              <label class="label form-label">Contact Name<span class="star">*</span></label>
              <input v-model="contactName" type="text" class="form-control ps-0" placeholder="Contact Name">
            </div>
            <div class="col-lg-6 mb-4">
              <label class="label form-label">Contact Number<span class="star">*</span></label>
              <input v-model="contactNumber" type="text" class="form-control ps-0" placeholder="Contact Number">
            </div>
            <div class="col-lg-6 mb-4">
              <label class="label form-label">Email<span class="star">*</span></label>
              <input v-model="email" type="email" class="form-control ps-0" placeholder="Email">
            </div>
            <div class="col-lg-6 mb-5">
              <label class="label form-label">Message<span class="star">*</span></label>
              <input v-model="message" type="text" class="form-control ps-0" placeholder="Say Hello !">
            </div>
            <button class="btn-contact mb-2" @click.prevent="save">Submit</button>
          </form>
        </div>
        <div class="col-lg-6 right-part font-light">
          <div class="row p-5">
            <div class="col-lg-6">
              <img
                  alt="phone"
                  src="../assets/images/contactus/phone.png"
                  class="mb-5"
              />
              <div class="info-title mb-2">Work and general inquiries</div>
              <div class="mb-4">+971 658 2627 <br> +971 50 990 6551</div>
              <div class="info-title mb-2">Assistance hours:</div>
              <div class="mb-5">Monday – Saturday <br> 8 am to 5 pm</div>
            </div>
            <div class="col-lg-6">
              <img
                  alt="mail"
                  src="../assets/images/contactus/mail.png"
                  class="mb-5"
              />
              <div class="info-title mb-2">Post address</div>
              <div class="mb-5">
                Khalidya Al Ahlya Tower <br>
                Block A M Floor <br>
                ABU DHABI <br>
                P.O. Box 63276
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0">
          <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d58103.189276925776!2d54.3157051103214!3d24.469883600000003!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb26436f8cd04386e!2sahlia%20tower!5e0!3m2!1sen!2stn!4v1638870039857!5m2!1sen!2stn"
              width="100%"
              height="600"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  </section>

  <section class="footer-section mt-5">
    <div class="container">
      <div class="row align-items-end justify-content-between">
        <div class="col-lg-6">
          <div class="sub-title">Careers</div>
          <div class="section-title mb-3">Join our team</div>
        </div>
        <div class="col-lg-6 d-flex justify-content-end">
          <button class="btn-contact">
            See Open Positions <span class="fw-bold ms-1">&#129042;</span>
          </button>
        </div>
      </div>
      <hr class="line"/>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: 'Contact-us',
  data() {
    return {
      businessName: '',
      contactName: '',
      contactNumber: '',
      email: '',
      message: '',
      success: '',
    }
  },
  methods: {
    reset() {
      this.businessName = '';
      this.contactName = '';
      this.contactNumber = '';
      this.email = '';
      this.message = '';
    },
    async save() {
      let data = {
        'businessName': this.businessName,
        'contactName': this.contactName,
        'contactNumber': this.contactNumber,
        'email': this.email,
        'message': this.message,
      }

      await axios.post('/api/contact-us', data)
          .then(() => {
            this.success = 'Contact Form Submitted!';
          })
      this.reset();
    }
  }
}
</script>

<style>
@import '../assets/styles/contactus.css';
</style>
